import {
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSSelectField from "../../Components/Select/WSSelect";
import { WSIcons } from "../../commonFunctions/iIcons";

export const Price: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();


  return (
    <>
          
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3,
          }}
        >
 <Grid container spacing={2}>

                <Grid item xs={12} >
                    <Typography fontWeight={"bold"} >
                         Sale Price
                        </Typography>
                    </Grid>

         
        <Grid item xs={12} sm={3}>
        <WSTextField
            label={"Sale Price"}
            {...register("salePrice")}
            id="salePrice"
            name="salePrice"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
         <Grid item xs={12} sm={3}>
         <WSSelectField
                rules={{ required: true }}
                control={control}
                id="sale"
                {...register("sale")}
                name="sale"
                label=""
                defaultValue={'Without Tax'}
              />
        </Grid>
        <Grid item xs={12} sm={3}>
        <WSTextField
            label={"Disc. on Sale Price"}
            {...register("disconsalePrice")}
            id="disconsalePrice"
            name="disconsalePrice"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
          <Grid item xs={12} sm={3}>
         <WSSelectField
                rules={{ required: true }}
                control={control}
                id="perc"
                {...register("perc")}
                name="perc"
                label=""
                defaultValue={'Percentage'}
              />
        </Grid>
        <Grid item xs={12}>
              <span style={{color:"blue"}}><WSIcons.AddIcon/> Add wholesale Price</span>     
                </Grid>
             
      </Grid>
        </Grid>
           
    </>
  );
});
